import { createParam } from 'solito'
import { useArticleQuery } from './queries'
import { ArticleScreen } from './article-screen'

const { useParam } = createParam<{ slug: string }>()

export interface ArticleScreenContainerProps {
  preview?: boolean
}

export const ArticleScreenContainer = (props: ArticleScreenContainerProps) => {
  const [slug] = useParam('slug')
  const { loading, data } = useArticleQuery({ slug: slug || '', draft: !!props.preview })

  return <ArticleScreen loading={loading} article={data?.Articles?.docs[0]} />
}
